import React from 'react';
import proptypes from 'prop-types';
import { Typography, Badge } from '@one-thd/sui-atomic-components';

const { string: stringType, bool: boolType } = proptypes;

const SUCCESS_STATUSES = ['complete', 'in transit', 'shipped', 'delivered'];
const WARNING_STATUSES = ['delayed', 'backordered'];

// "returned", "in progress", and any other unmapped status fall through to this default.
function getTileBadgeColor(orderStatus) {
  const formattedOrderStatus = orderStatus?.toLowerCase();
  if (SUCCESS_STATUSES.includes(formattedOrderStatus)) {
    return 'success';
  }
  if (WARNING_STATUSES.includes(formattedOrderStatus)) {
    return 'warning';
  }
  return 'primary';
}

export function TableStatusMessage({ orderStatus = null }) {
  if (!orderStatus) {
    return <div className="sui-h-20" data-testid="orderStatus" />;
  }

  return (
    <div
      className="sui-flex sui-items-center sui-break-words sui-overflow-hidden sui-w-24 sui-h-20"
      data-testid="orderStatus"
    >
      <Typography variant="body-base">{orderStatus}</Typography>
    </div>
  );
}

TableStatusMessage.propTypes = {
  orderStatus: stringType,
};

export function CardStatusMessage({ orderStatus = null }) {
  if (!orderStatus) {
    return <div className="sui-mb-3" data-testid="orderStatus" />;
  }

  return (
    <div className="sui-mb-3" data-testid="orderStatus">
      <Typography variant="body-base">{orderStatus}</Typography>
    </div>
  );
}

CardStatusMessage.propTypes = {
  orderStatus: stringType,
};

export function TileStatusMessage({ orderStatus = null, isOnline = false }) {
  const showInStoreBadge = !isOnline;

  if (!orderStatus && !showInStoreBadge) {
    return <div className="sui-self-start sui-mb-2" data-testid="orderStatus" />;
  }

  return (
    <div className="sui-self-start sui-mb-2 sui-flex sui-flex-wrap sui-gap-2" data-testid="orderStatus">
      {orderStatus && (
        <Badge variant="outline" color={getTileBadgeColor(orderStatus)}>{`Status: ${orderStatus}`}</Badge>
      )}
      {showInStoreBadge && (
        <Badge variant="outline" color="primary">In Store Purchase</Badge>
      )}
    </div>
  );
}

TileStatusMessage.propTypes = {
  orderStatus: stringType,
  isOnline: boolType,
};
